import { StatePreV4, StateV4 } from './4_migrate_assekuranztarif.interface';

export const migrateAssekuranztarif = (previousState: StatePreV4, newVersion: number): StateV4 => {
  const newState = {
    ...previousState,
    version: newVersion,
    versicherungsnehmer: {
      ...previousState.versicherungsnehmer,
      isAssekuranztarif: previousState.versicherungsnehmer.isFinanzdienstleistertarif,
    },
  };
  delete newState.versicherungsnehmer.isFinanzdienstleistertarif;
  return newState;
};
